
import React, { useState, useEffect } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { ToastContainer, toast, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LinearProgressWithLabel from '../components/NewProgressBar';

const NewFinancialReport = () => {
  const [year, setYear] = useState('');
  const [progress, setProgress] = useState(0);
  const [showProgress, setShowProgress] = useState(false);
  const [reportGenerated, setReportGenerated] = useState(false);

  const handleGetReport = () => {
    if (!year) {
      toast.error("Please select a year before generating the report.");
      return;
    }

    setProgress(0);
    setShowProgress(true);
    setReportGenerated(false);

    let timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 99) {
          clearInterval(timer);
          setTimeout(() => setProgress(100), 1000);
          return prev;
        }
        return prev + 4;
      });
    }, 30);
  };

  
  useEffect(() => {
    if (progress === 100 && !reportGenerated) {
      toast.success(`The report has been successfully generated.`);
      setReportGenerated(true);
    }
  }, [progress, reportGenerated]);

  return (
    <>
    <p className="font-[600] text-[20px] text-[#212121] mb-3">Reports</p>
    <div className="bg-white rounded-xl shadow py-[4%] w-full">
      <div>
        <h2 className="text-[22px] font-[600] text-center mb-2">Get Financial Reports</h2>
        <p className="text-lg text-[#212121] text-center mb-6 max-w-[600px] mx-auto font-[400]">
          Configure and generate your financial reports with customizable parameters
        </p>
      </div>

      <div className="bg-white rounded-2xl p-8 border w-full max-w-3xl mx-auto mt-[2%]">
        <div className="sm:grid sm:grid-cols-1 md:flex md:flex-wrap md:justify-between items-end gap-4 mb-6 py-[5%]">
          <div className="sm:grid sm:grid-cols-1 sm:w-[100%] flex flex-col md:w-[70%]">
            <label className="text-[14px] text-[#4B5563] font-[500] mb-1">Year</label>
            <select
              className="border border-[#204887] w-full rounded-[10px] px-6 py-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400 text-[12px]"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <option value="" disabled>Select Year</option>
              <option value="2024">2024</option>
              <option value="2023">2023</option>
              <option value="2022">2022</option>
            </select>
          </div>

          <button
            onClick={handleGetReport}
            className="bg-[#204887] text-white font-medium px-12 py-4 rounded-[10px] hover:bg-[#ffffff] hover:text-[#204887] hover:border hover:border-[#204887]"
          >
            Get Report
          </button>
        </div>

        {showProgress && (
          <div className="bg-[#D0E1FD] p-4 rounded-xl space-y-2">
            <div className="flex justify-between items-center">
            <span className="font-semibold text-[#204887]">
            {progress === 100 ? "Completed" : "Report Generating..."}
            </span>
              <FaCheckCircle className="text-[#204887]" size={15} />
            </div>
            <div className="w-full">
              <LinearProgressWithLabel value={progress} />
            </div>
          </div>
        )}
      </div>
    </div>
    </> 
  );
};

export default NewFinancialReport;
